<template>
    <Card class="bg-white">
        <template #header>
            <div class="flex items-center justify-between w-full p-4">
                <h3 class="text-lg font-medium text-gray-900">Supporting Documents</h3>
            </div>
        </template>
        <div class="space-y-4">
            <div v-if="displayAttachments && displayAttachments.length">
                <ul>
                    <li
                        v-for="(attachment, i) in displayAttachments"
                        :key="i"
                        class="flex pb-4 pt-2 text-sm"
                        :class="{ 'border-b border-b-gray-400 mb-2': i !== displayAttachments.length - 1 }"
                    >
                        <img :src="attachment.iconUrl" class="w-10 h-10 mr-4" alt="" aria-hidden="true" />
                        <a class="break-all whitespace-normal" target="_blank" :href="config.public.boardDomain + '/' + publicSiteData.organization_slug + '/public-site-data/meetings/' + route.params.meeting_slug + '/documents/' + attachment.uuid.short_slug + '/view'" :aria-label="`${attachment.name || attachment.title} (opens in new tab)`">
                            {{ attachment.name || attachment.title }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </Card>
</template>

<script setup>
import { computed } from "vue";
import Card from "~/components/ui/Card.vue";

const props = defineProps({
    meeting: {
        type: Object,
        required: true
    },
    attachments: {
        type: Array,
        default: null
    }
});

const config = useRuntimeConfig();
const route = useRoute();
const publicSiteData = useState('publicSiteData');

// Use passed attachments if provided, otherwise fall back to meeting.attachments
const displayAttachments = computed(() => {
    return props.attachments || props.meeting.attachments || [];
});
</script>